import { useContext } from '@nuxtjs/composition-api'

export default function () {
  return useContext().app.i18n
}
